/** An entry-score band as any CDP payload carries it — the scheme rides on `type`. */
export interface EntryScoreBand {
  type?: string | null;
  min?: number | null;
  median?: number | null;
  max?: number | null;
}

// The chip label follows the band's scheme (same pattern as InstitutionNumbers);
// unknown types fall back to a generic entry-score label rather than lying "ATAR".
const ENTRY_SCORE_CHIP_KEYS: Record<string, string> = {
  atar: 'unified.cdp.atarChip',
  gpa: 'unified.cdp.gpaChip',
  sat: 'unified.cdp.satChip',
};
const GENERIC_ENTRY_SCORE_CHIP_KEY = 'unified.cdp.entryScoreChip';

export const entryScoreChipKey = (type?: string | null): string => {
  const scheme = type?.toLowerCase();
  return (scheme != null ? ENTRY_SCORE_CHIP_KEYS[scheme] : undefined) ?? GENERIC_ENTRY_SCORE_CHIP_KEY;
};

/**
 * The one figure the chip shows: the median where the index has one, otherwise
 * the minimum entry score. SAT bands are whole numbers; the other schemes read
 * as two-decimal figures (60.00, 3.60). Null when the band carries neither.
 */
export const entryScoreFigure = (
  entryScore?: EntryScoreBand | null,
): { value: number; fractionDigits: number } | null => {
  const value = entryScore?.median ?? entryScore?.min;
  if (typeof value !== 'number') {
    return null;
  }
  return { value, fractionDigits: entryScore?.type?.toLowerCase() === 'sat' ? 0 : 2 };
};
